import React from "react";
import PageHeader from "../Common/PageHeader";
import Subheading from "../Common/Subheading";
import InteractionsLinks from "./InteractionsLinks";
import InteractionsIcon from "../../assets/icons/interactions.svg2";
import NewFeature from "../Builder/Components/NewFeature";

export default function Interactions() {
  return (
    <div className="mb-5">
      <PageHeader
        Icon={InteractionsIcon}
        heading="Interactions"
        subheading="Lorem, ipsum dolor sit amet consectetur adipisicing elit."
      />
      <InteractionsLinks />
      <NewFeature>
        <Subheading
          Icon={InteractionsIcon}
          heading="Interactions Summary"
          subheading="Lorem ipsum dolor, sit amet consectetur adipisicing elit."
        />
      </NewFeature>
    </div>
  );
}
